module.exports = __webpack_public_path__ + "img/red.94406cc9.png";